import { FleekError } from './FleekError';

type Framework = {
  id?: string;
  name?: string;
};

type SiteFrameworkAlreadyExistsErrorOptions = {
  framework: Framework;
};

export class SiteFrameworkAlreadyExistsError extends FleekError<SiteFrameworkAlreadyExistsErrorOptions> {
  public name = 'SiteFrameworkAlreadyExistsError';

  toString = () => `Site framework already exists.`;
}
